import type { IconSvgObject } from './types';

const VoiceToTextIcon: IconSvgObject = [
  ["path", { d: "M16 11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11V6C8 3.79086 9.79086 2 12 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 18V22M12 22H15M12 22H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 12C18.7174 15.3914 15.8824 18 12.4792 18H11.5208C8.11765 18 5.28262 15.3914 5 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18.5 2.5V7.5M18.5 7.5H17M18.5 7.5H20M21.5 3C21.5 2.44772 21.0523 2 20.5 2H16.5C15.9477 2 15.5 2.44772 15.5 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default VoiceToTextIcon;
